import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { reformatLot } from '../../../selectors/lots'

const initial = {
  data: {},
  bids: [],
  bidInfo: null,
  similar: [],
  bidMessage: null,
  fromListName: null,//то, с какого списка пользователь перешел на страницу лота
}

const getInfoActions = generateActions('lots/single/GET_INFO')
const setCommentsActions = generateActions('lots/single/SET_INFO')

const subscribeActions = generateActions('lots/single/SUBSCRIBE')
const getSimilarActions = generateActions('lots/single/GET_SIMILAR')
const finishBidActions = generateActions('lots/single/FINISH_BID')

const sendExternalBidNotifyActions = generateActions('lots/single/NOTIFY_BID')

export const setFromList = createAction('lots/single/SET_FROM_LIST', listName => ({ listName }))

export const getFullInfo = createAction(
  API_CONST,
  (lotId, typelot) => ({
    url: `lots/${lotId}`,
    actions: getInfoActions,
	params: typelot,
  }),
  (lotId, options = {}) => ({ noRewrite: options.noRewrite || false})
)

export const getSimilar = createAction(
  API_CONST,
  lotId => ({
    actions: getSimilarActions,
    url: `lots/${lotId}/similar`
  })
)

export const subscribe = createAction(
  API_CONST,
  (lotId, flag) => ({
    method: 'POST',
    actions: subscribeActions,
    params: { doSubscribe: flag },
    url: `lots/${lotId}/subscribe`
  }),
  (lotId, flag) => ({ flag })
)

export const finishBid = createAction(
  API_CONST,
  (lotId, bidId) => ({
    actions: finishBidActions,
    url: `lots/${lotId}/bid/${bidId}`
  })
)

export const sendComment = createAction(
  API_CONST,
  (data = {}, lotId) => ({
    method: 'POST',
    params: { ...data},
    url: `lots/${lotId}/personComments/add`,
    actions: setCommentsActions
  })
)

export const sendExternalBidNotify = createAction(
  API_CONST,
  (lotId) => ({
    method: 'POST',
    url: `lots/${lotId}/bids/new/external`,
    actions: sendExternalBidNotifyActions
  })
)

const reformatBids = (items = []) => items.map(item => ({
  _id: item._id,
  sum: item.value,
  date: item.created,
  name: item.user.name,
  targetId: item.user._id,
  isAnonymous: item.isAnonymous,
  isWinner: item.isWinner,
  userPaymentId: item.userPaymentId,
  currency: item.currency && item.currency.symbol
}))

export default handleActions({
  [getInfoActions[0]]: (state, { meta }) => meta.noRewrite ? ({ ...state }) : ({ ...initial, fromListName: state.fromListName }),
  [getInfoActions[1]]: (state, { payload }) => ({
    ...state,
    data: payload,
    bids: reformatBids(payload.bids)
  }),
  [subscribeActions[1]]: (state, { meta }) => ({ ...state, data: { ...state.data, isSubscribed: meta.flag } }),
  [getSimilarActions[1]]: (state, { payload = [] }) => ({
    ...state,
    similar: payload.map(lot => reformatLot(lot))
  }),
  [setCommentsActions[1]]: (state, { payload = [] }) => ({
    ...state, data: { ...state.data }
  }),
  [finishBidActions[1]]: (state, { payload }) => {
    //console.log(payload)
    return ({ ...state, bidMessage: payload.message || null })
  },
  [setFromList]: (state, { payload }) => ({ ...state, fromListName: payload.listName}),
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/lots/single.js